import React from 'react'
import moment from 'moment'
import { Box, Button, CircularProgress } from '@mui/material'
import { useSnackbar } from 'notistack'
import DownloadIcon from '@mui/icons-material/Download'
import { usePostExportEndUserScratchCard } from '../../../../api/promotions/end-user/end-user-scratch-card'

const Toolbar = () => {
  const { enqueueSnackbar } = useSnackbar()
  const exportApi = usePostExportEndUserScratchCard()

  const handleExport = async () => {
    try {
      // Get file
      const res = await exportApi.mutateAsync()

      // Get timestamp
      const timestamp = moment().format('YYYYMMDDHHmmss')
      const url = URL.createObjectURL(res.data)

      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `promotions_end_user_scratch_card_redemption_${timestamp}.xlsx`)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      // Display error on popup
      enqueueSnackbar(error?.response?.data?.message ?? 'Failed to export data', {
        variant: 'error',
        autoHideDuration: 7000,
      })
    }
  }

  return (
    <Box display='flex' justifyContent='flex-end' m={1}>
      <Button
        startIcon={exportApi.isLoading ? <CircularProgress size='1.5rem' /> : <DownloadIcon />}
        onClick={handleExport}
        disabled={exportApi.isLoading}
      >
        Export Data
      </Button>
    </Box>
  )
}

export default Toolbar
